import React from 'react'
import PropTypes from 'prop-types'
import './modal.css'

const Modal = ({children, expanding}) =>
    <div className="vat-modal">
        <div className={'modal-container' + (expanding ? ' expanding' : '')}>
            {children}
        </div>
    </div>   

Modal.propTypes = {
    children: PropTypes.node,
    expanding: PropTypes.bool
}

Modal.defaultProps = {
    expanding: false
}

export default Modal




// WEBPACK FOOTER //
// ./src/felles/modal/modal.jsx